// app/sort-toggle.ts — следующий список сортировок после щелчка по заголовку колонки.

import { SORT_DIRECTION_OBJ, type SortClause } from "../domain";

/**
 * Без Shift: цикл «возрастание → убывание → без сортировки», остальные колонки сбрасываются.
 * С Shift: колонка добавляется к текущим, затем меняет направление, затем удаляется.
 * Колонки-действия и колонки с отключённой сортировкой отсеивает вызывающий компонент.
 */
export function nextSortClauses(
  sort: SortClause[],
  columnId: string,
  shiftKey: boolean,
): SortClause[] {
  const existing = sort.find((s) => s.column === columnId);
  if (shiftKey) {
    if (!existing) return [...sort, { column: columnId, direction: SORT_DIRECTION_OBJ.ASC }];
    if (existing.direction === SORT_DIRECTION_OBJ.ASC) {
      return sort.map((s) =>
        s.column === columnId ? { ...s, direction: SORT_DIRECTION_OBJ.DESC } : s,
      );
    }
    return sort.filter((s) => s.column !== columnId);
  }
  if (!existing) return [{ column: columnId, direction: SORT_DIRECTION_OBJ.ASC }];
  if (existing.direction === SORT_DIRECTION_OBJ.ASC) {
    return [{ column: columnId, direction: SORT_DIRECTION_OBJ.DESC }];
  }
  return [];
}
